<template>
  <div class='table'>
    <b-table ref='table' selectable select-mode='multi' :fields='fields' striped hover :items='tableData'
             :busy.sync='isBusy' @row-selected='onRowSelected'>
      <template #head(selected)>
        <BFormCheckbox v-model='isAllSelected' @change='onAllCheckChange' />
      </template>
      <template #cell(selected)='{ rowSelected,index }'>
        <BFormCheckbox :checked='rowSelected' @change='onCheckChange($event,index)' />
      </template>
      <template v-for='(_, slotName) of $scopedSlots' v-slot:[slotName]='scope'>
        <slot :name='slotName' v-bind='scope' />
      </template>
    </b-table>
  </div>
</template>

<script>
export default {
  props: {
    tableData: {
      type: [Function, Array],
      default: () => []
    },
    fields: Array
  },
  data() {
    return {
      isBusy: false,
      isAllSelected: false
    }
  },
  methods: {
    onRowSelected(items) {
      this.$emit('onSelect', items)
    },
    onAllCheckChange(val) {
      if (val) {
        this.$refs['table'].selectAllRows()
      } else {
        this.$refs['table'].clearSelected()
      }
    },
    onCheckChange(val, i) {
      if (val) {
        this.$refs['table'].selectRow(i)
      } else {
        this.$refs['table'].unselectRow(i)
      }
    }
  }
}
</script>

<style scoped>

</style>
